export const debounce = (func, wait, immediate = false) => {
  let timer = null;
  
  return function(...args) {
    if (timer) clearTimeout(timer);
    
    if (immediate) {
      // 如果已经过了等待时间，则立即执行
      const callNow = !timer;
      
      timer = setTimeout(() => {
        timer = null;
      }, wait);
      
      if (callNow) {
        func.apply(this, args);
      }
    } else {
      // 延迟执行版本
      timer = setTimeout(() => {
        func.apply(this, args);
        timer = null;
      }, wait);
    }
  };
} 